import { inject } from '@angular/core'
import { CanActivateChildFn, Router } from '@angular/router'
import { AppStore } from '../app.store'
import { ToastrService } from 'ngx-toastr'
import { Me } from 'src/app/shared/interfaces/me/me.interface'
import { toObservable } from '@angular/core/rxjs-interop'
import { filter, first, map } from 'rxjs'

export const trialGuardFn: CanActivateChildFn = (_, state) => {
    const appStore = inject(AppStore)
    const router = inject(Router)
    const toastr = inject(ToastrService)

    const checkTrialStatus = (me: Me | null) => {
        const trialExpired = !me?.subscription.onTrial && me?.subscription.paymentDetailsRequired

        if (trialExpired) {
            const adminToastMessage = 'Your trial period has ended, please provide payment details.'
            const userToastMessage = 'Your trial period has ended, an admin must login and provide payment details.'
            const adminPaymentUrl = '/admin/subscription/payment-details'
            const userHomeUrl = '/dashboard/home'

            const toastMessage = me?.isAdmin ? adminToastMessage : userToastMessage
            const redirectUrl = me?.isAdmin ? adminPaymentUrl : userHomeUrl

            if (toastr.previousToastMessage !== toastMessage) {
                toastr.error(toastMessage, 'Trial Ended', {
                    disableTimeOut: true,
                    tapToDismiss: false,
                    closeButton: false,
                    easeTime: 0,
                })
            }

            if (state.url !== redirectUrl) {
                router.navigateByUrl(redirectUrl)
            }
        }

        return true
    }

    if (appStore.meLoaded()) {
        return checkTrialStatus(appStore.me())
    }

    appStore.loadMe()

    return toObservable(appStore.meLoaded).pipe(
        filter(Boolean),
        first(),
        map(() => checkTrialStatus(appStore.me()))
    )
}
